import { t as e } from "../../utils-DiFe-_ei.js";
import { Skeleton as t } from "../../foundations/skeleton.js";
import "../../skeleton-bhKtal4a.js";
import { Typography as n } from "../../foundations/typography.js";
import "../../typography-CTPDhvds.js";
import { useEffect as r, useId as i, useState as a } from "react";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
//#region src/components/loading/DetailPageSkeleton/DetailPageSkeleton.tsx
var c = 3, l = 4;
function u({ maxWidth: n = "narrow", sections: r = 2, sidebar: i = !1 }) {
	let a = n === "full" ? "" : e("mx-auto", n === "wide" ? "max-w-[1100px]" : "max-w-3xl"), u = /* @__PURE__ */ o("div", {
		className: "space-y-6",
		children: Array.from({ length: r }, (e, n) => /* @__PURE__ */ s("div", {
			className: "bg-card rounded-xl border p-6 shadow-sm",
			children: [/* @__PURE__ */ o(t, {
				variant: "text",
				className: "h-5 w-40"
			}), /* @__PURE__ */ o("div", {
				className: "mt-5 space-y-4",
				children: Array.from({ length: c }, (e, n) => /* @__PURE__ */ s("div", {
					className: "space-y-1.5",
					children: [/* @__PURE__ */ o(t, {
						variant: "text",
						className: "h-3.5 w-24"
					}), /* @__PURE__ */ o(t, {
						variant: "rect",
						className: "h-9 w-full"
					})]
				}, n))
			})]
		}, n))
	});
	return /* @__PURE__ */ s("div", {
		className: e("p-8", a),
		children: [/* @__PURE__ */ s("div", {
			className: "mb-8 flex items-start justify-between",
			children: [/* @__PURE__ */ s("div", { children: [/* @__PURE__ */ o(t, {
				variant: "text",
				className: "h-7 w-56"
			}), /* @__PURE__ */ o(t, {
				variant: "text",
				className: "mt-3 h-4 w-72"
			})] }), /* @__PURE__ */ o(t, {
				variant: "rect",
				className: "h-9 w-24"
			})]
		}), i ? /* @__PURE__ */ s("div", {
			className: "flex flex-col gap-6 md:grid md:grid-cols-[1fr_320px] md:items-start md:gap-8",
			children: [/* @__PURE__ */ o("div", { children: u }), /* @__PURE__ */ o("div", {
				className: "bg-card space-y-4 rounded-xl border p-6 shadow-sm md:sticky md:top-5",
				children: Array.from({ length: l }, (e, n) => /* @__PURE__ */ s("div", {
					className: "space-y-1.5",
					children: [/* @__PURE__ */ o(t, {
						variant: "text",
						className: "h-3 w-20"
					}), /* @__PURE__ */ o(t, {
						variant: "text",
						className: "h-4 w-32"
					})]
				}, n))
			})]
		}) : u]
	});
}
//#endregion
//#region src/components/loading/Spinner/Spinner.tsx
function d({ size: t = 32, strokeWidth: n = 3, className: r }) {
	let a = i(), c = (t - n) / 2, l = 2 * Math.PI * c, u = l * .75;
	return /* @__PURE__ */ s("svg", {
		className: e("animate-spin", r),
		width: t,
		height: t,
		viewBox: `0 0 ${t} ${t}`,
		fill: "none",
		role: "status",
		"aria-label": "Loading",
		children: [/* @__PURE__ */ o("defs", { children: /* @__PURE__ */ s("linearGradient", {
			id: a,
			x1: "0%",
			y1: "0%",
			x2: "100%",
			y2: "100%",
			children: [/* @__PURE__ */ o("stop", {
				offset: "0%",
				stopColor: "currentColor",
				stopOpacity: "0"
			}), /* @__PURE__ */ o("stop", {
				offset: "100%",
				stopColor: "currentColor",
				stopOpacity: "1"
			})]
		}) }), /* @__PURE__ */ o("circle", {
			cx: t / 2,
			cy: t / 2,
			r: c,
			stroke: `url(#${a})`,
			strokeWidth: n,
			strokeLinecap: "round",
			strokeDasharray: `${u} ${l}`
		})]
	});
}
//#endregion
//#region src/components/loading/PageLoader/PageLoader.constants.ts
var f = [
	"Loading your workspace…",
	"Fetching the good stuff…",
	"Almost there…",
	"Preparing your data…"
], p = 2e3, m = {
	sm: 20,
	md: 32
};
//#endregion
//#region src/components/loading/PageLoader/PageLoader.tsx
function h({ messages: t = f, intervalMs: i = p, size: c = "md", fullScreen: l = !0 }) {
	let [u, h] = a(() => Math.floor(Math.random() * t.length));
	return r(() => {
		let e = setInterval(() => {
			h((e) => (e + 1) % t.length);
		}, i);
		return () => clearInterval(e);
	}, [t.length, i]), /* @__PURE__ */ s("div", {
		className: e("flex flex-col items-center justify-center gap-4", l && "min-h-svh"),
		children: [/* @__PURE__ */ o(d, {
			size: m[c],
			className: "text-muted-foreground"
		}), /* @__PURE__ */ o(n, {
			variant: "body",
			color: "muted",
			children: t[u]
		})]
	});
}
//#endregion
export { u as DetailPageSkeleton, h as PageLoader, d as Spinner };

//# sourceMappingURL=index.js.map